import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import RichTextEditor from 'react-rte';
import { Input } from '../../Ui/Input';
import { Button } from "../../Ui/Button";
import DropDown from '../../Ui/DropDown';
import { serviceCards, arabicServiceCards } from '../types';
import * as formActions from '../../../Redux/Actions/form';
import { WorkFlowActionsContainer } from '../styles';

const CreateServiceCard = () => {

    const [newTitle, setNewTitle] = useState(false);
    const [title, setTitle] = useState('');
    const [arabicTitle, setArabicTitle] = useState('');
    const [descriptionMarkup, setDescriptionMarkup] = useState(RichTextEditor.createEmptyValue());
    const [arabicDescriptionMarkup, setArabicDescriptionMarkup] = useState(RichTextEditor.createEmptyValue());
    const dispatch = useDispatch();
    const editData = useSelector(({Form}) => Form.editServiceCard);

    useEffect(() => {
        dispatch(formActions.editServiceCard({}));
    }, [dispatch]);

    useEffect(() => {
        if (editData && editData.title){
            let dropDownTitle = serviceCards.filter(({label}) => label === editData.title);
            let arabicDropDownTitle = arabicServiceCards.filter(({label}) => label === editData.arabicTitle);
            if(dropDownTitle.length !== 0) {
                setNewTitle(false);
                setTitle(dropDownTitle[0]);
                setArabicTitle(arabicDropDownTitle[0]);
            }else{
                setNewTitle(true);
                setTitle(editData.title);
                setArabicTitle(editData.arabicTitle);
            }
            setDescriptionMarkup(RichTextEditor.createValueFromString(editData.description, 'html'));
            setArabicDescriptionMarkup(RichTextEditor.createValueFromString(editData.arabicDescription, 'html'));
        }
    }, [editData]);

    const handleServiceCard = () => {
        dispatch(formActions.createServiceCard({id: (typeof editData.id === 'number') ? editData.id : '', title: title.label ? title.label : title, description: descriptionMarkup.toString('html'), arabicTitle: arabicTitle.label ? arabicTitle.label : arabicTitle, arabicDescription: arabicDescriptionMarkup.toString('html')}));
        setTitle('');
        setArabicTitle('');
        setDescriptionMarkup(RichTextEditor.createEmptyValue());
        setArabicDescriptionMarkup(RichTextEditor.createEmptyValue());
    };

    const toolbarConfig = {
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
    };

    return(
        <WorkFlowActionsContainer>
            <div className="d-flex align-center justify-content-between mb-8">
                <h4 style={{color: '#333', margin: 0}}>Service Card</h4>
                <div className="row align-items-center">
                    <label className="col-form-label font-weight-bold p-0">New Title</label>
                    <div className="col-lg-9 col-xl-6">
                        <span className="switch switch-sm">
                            <label>
                                <input type="checkbox" checked={newTitle} name="dynamic title" onChange={() => {setNewTitle(!newTitle); setTitle(''); setArabicTitle('')}} />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                {newTitle ? <>
                    <Input label={'Title'} inline={true} value={title} type={'text'} placeholder={'Type your service card title'} onChange={e => setTitle(e.target.value)} />
                    <Input label={'Arabic Title'} inline={true} value={arabicTitle} type={'text'} placeholder={'Type your service card arabic title'} onChange={e => setArabicTitle(e.target.value)} />
                </>
                : <>
                    <DropDown label={'Title'} options={serviceCards} inline={true} value={title} onChange={(value) => {setTitle(value); setArabicTitle(arabicServiceCards.filter(({value: id}) => id === value.value)[0])}} /> 
                    <DropDown label={'Arabic Title'} options={arabicServiceCards} inline={true} value={arabicTitle} onChange={(value) => {setTitle(serviceCards.filter(({value: id}) => id === value.value)[0]); setArabicTitle(value);}} />
                </>}
                <p className="mb-1">English Editor</p>
                <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={descriptionMarkup} onChange={(value) => setDescriptionMarkup(value)} />
                <p className="mb-1">Arabic Editor</p>
                <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={arabicDescriptionMarkup} onChange={(value) => setArabicDescriptionMarkup(value)} />
                <Button disabled={((title === '') || (descriptionMarkup === '')) && ((arabicTitle === '') || (arabicDescriptionMarkup === ''))} style={{marginTop: '10px', display: 'block', margin: '0 auto'}} onClick={handleServiceCard}>{editData.title ? 'Update' : 'Add'}</Button>
            </div>
        </WorkFlowActionsContainer>
    );
};

export default CreateServiceCard;